<template>
  <section>
    <div class="solution">
      <div class="solution__content">
        <div class="solution__title">01. ПО для музейного киоска</div>
        <div class="solution__description">
          <p>Успешно апробированное решение для реализации интерактивного музея - удобный каталог экспонатов, единая административная панель, все необходимые возможности, готовые «из коробки». Удобное и простое в использовании приложение.
          </p>
          <ul>
            <li>Категории экспонатов и удобная навигация по ним</li>
            <li>Фильтрация экспонатов по категориям и тегам</li>
            <li>Фото- и видеоматериалы</li>
            <li>Административная панель для управления экспонатами (единая система на все киоски, разворачивается на отдельном сервере)</li>
            <li>Настройка интерфейса под фирменный стиль заказчика (единоразовая реализация с нашей стороны)</li>
            <li>Поддержка режима для людей с ограниченными возможностями</li>
          </ul>
          <table>
            <tbody>
              <tr>
                <td>Стоимость лицензии «под ключ» на одно устройство, руб.</td>
                <td>150 000</td>
              </tr>
              <tr>
                <td>Стоимость лицензии на каждое дополнительное устройство, руб.</td>
                <td>70 000</td>
              </tr>
              <tr>
                <td>Стоимость лицензии на неограниченное количество устройств, руб.</td>
                <td>400 000</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="solution__cta">
        <router-link to="/solution-request?type=museum" class="solution__button button">Запросить консультацию</router-link>
      </div>
    </div>
    <div class="solution">
      <div class="solution__content">
        <div class="solution__title">02.  ПО для интерактивной AR-фотосессии</div>
        <div class="solution__description">
          <p>Интерактивное решение для различных мероприятий и презентаций - позволяет элегантно собирать данные аудитории, предложив развлекательный интерактив. Например, ПО позволяет посетителю сфотографироваться с любимым футболистом в перерыве футбольного матча, с музыкантом перед концертом либо с персонажем на кинопремьере. При необходимости мы обеспечиваем техническое сопровождение предварительной подготовки контента (организация съемок, съемка, продакшн и загрузка контента в систему). Поддержка разрешения вплоть до 4К в зависимости от целевого устройства.</p>
          <p>Для обеспечения необходимого уровня производительности, комплектация целевого устройства должна включать видеокарту.</p>
          <ul>
            <li>Фотография с одним персонажем</li>
            <li>Фотография с группой персонажей</li>
            <li>Стилизация интерфейса под фирменный стиль заказчика</li>
            <li>Административная панель для управления контентом и настройками ПО</li>
            <li>Модуль фотографии с AR-эффектом</li>
            <li>Сбор данных пользователя (отправка фотографии на электронную почту)</li>
          </ul>
          <table>
            <tbody>
              <tr>
                <td>Стоимость лицензии «под ключ» на одно устройство, руб.</td>
                <td>300 000</td>
              </tr>
              <tr>
                <td>Стоимость лицензии на каждое дополнительное устройство, руб.</td>
                <td>140 000</td>
              </tr>
              <tr>
                <td>Стоимость лицензии на неограниченное количество устройств, руб.</td>
                <td>600 000</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="solution__cta">
        <router-link to="/solution-request?type=ar" class="solution__button button">Запросить консультацию</router-link>
      </div>
    </div>
    <div class="solution">
      <div class="solution__content">
        <div class="solution__title">03. ПО Киоск-кассир</div>
        <div class="solution__description">
          <p>Решение позволяет быстро установить и настроить онлайн-терминал для заказа и оплаты товаров в магазинах и заведениях общепита, что решает проблему «бутылочного горлышка» на кассе и позволяет освободить время сотрудников на сбор и приготовление заказов клиента. ПО поддерживает интеграцию с терминалом оплаты и может принимать безналичную оплату. В случае наличной оплаты, терминал шлет данные на рабочее место кассира (1С-обмен либо JSON данные в любую другую систему), что позволяет кассиру принять наличную оплату за уже сформированный заказ.</p>
          <p>ПО позволит увеличить производительность торговой точки в часы пиковой загрузки, что положительно сказывается на выручке.</p>
          <ul>
            <li>Категории товаров, фильтрация по ним</li>
            <li>Теги и фильтрация по ним</li>
            <li>Акции и специальные предложения</li>
            <li>Изображения и описания товаров</li>
            <li>Двусторонняя интеграция с 1С</li>
            <li>Стилизация под фирменный стиль Заказчика</li>
            <li>Поддержка POS-терминала</li>
            <li>Поддержка фискального регистратора / интеграция с ОФД</li>
            <li>Удобный понятный интерфейс, обеспечивающий минимальный уровень отказов</li>
            <li>Возможность отправки данных заказа в webhook клиента (JSON-формат)</li>
          </ul>
          <table>
            <tbody>
              <tr>
                <td>Стоимость лицензии «под ключ» на одно устройство, руб.</td>
                <td>350 000</td>
              </tr>
              <tr>
                <td>Стоимость лицензии на каждое дополнительное устройство, руб.</td>
                <td>160 000</td>
              </tr>
              <tr>
                <td>Стоимость лицензии на неограниченное количество устройств, руб.</td>
                <td>1 000 000</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="solution__cta">
        <router-link to="/solution-request?type=cashier" class="solution__button button">Запросить консультацию</router-link>
      </div>
    </div>
  </section>
</template>
<script>
const name = "SolutionPrograms"

import SvgIcon from '@/components/SvgIcon.vue'

export default {
  name,
  components: {
    SvgIcon
  }
}

</script>
